import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import store from './store'
import vuetify from './plugins/vuetify'
import router from './router'
import { Plugin } from 'vue-responsive-video-background-player'
import { ValidationProvider } from 'vee-validate'

Vue.config.productionTip = false
Vue.use(Plugin)
new Vue({
  router,
  vuetify,
  i18n,
  store,
  ValidationProvider,
  render: h => h(App)
}).$mount('#app')
